<template>
  <el-dropdown @command="handleMenuCommand" trigger="click">
    <el-button size="mini" class="el-dropdown-link cursor-pointer">
      <i class="el-icon-more"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <!-- <el-dropdown-item command="chat">
                      <i class="el-icon-chat-line-square mr-2" />Chat with Agent
                    </el-dropdown-item>
                    <el-dropdown-item command="configure">
                      <i class="el-icon-edit mr-2" />Configure Agent
                    </el-dropdown-item> -->
      <el-dropdown-item command="knowledge">
        <i class="el-icon-notebook-2 mr-2" />Knowledge Base
      </el-dropdown-item>
      <!-- <el-dropdown-item command="prompt">
                      <i class="el-icon-s-opportunity mr-2" />Prompt Engineering
                    </el-dropdown-item> -->
      <!-- <el-dropdown-item command="collab">
                      <i class="el-icon-share mr-2" />Agent Collaboration
                    </el-dropdown-item>
                    <el-dropdown-item command="access">
                      <i class="fa fa-shield mr-2" />Permissions
                    </el-dropdown-item> -->
      <!-- <el-dropdown-item command="access">
                      <i class="el-icon-lock mr-2" />Access Control
                    </el-dropdown-item> -->
      <el-dropdown-item command="share">
        <i class="el-icon-share mr-2" />Share Agent
      </el-dropdown-item>
      <el-dropdown-item divided command="delete" style="color:red">
        <i class="el-icon-delete mr-2" />Delete Agent
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  name: 'AiAgentMoreDropdown',
  emits: ['command'],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleMenuCommand(command) {
      this.$emit('command', {command, item: this.item});
    }
  }
}
</script>